import React, { useEffect, useMemo, useState } from 'react'
import { Html, Line } from '@react-three/drei'
import { params } from '../../../../../../redux/reducers/reducer';

const OutLineSection = () => {

    const offsetCB = 0.16;
    const offsetHor = 0.15;
    const offsetVer = 0.2;

    const topLinePoints = useMemo(() => (
        [
            [-(params.p_w / 2 + offsetCB), params.lean_p_h + params.lean_p_w * params.b_l_t_r_p / 12 + offsetVer, -params.lean_p_d / 2 + parseInt(params.add_storage)],
            //right part
            [-(params.p_w / 2 + offsetCB), params.lean_p_h + params.lean_p_w * params.b_l_t_r_p / 12 + offsetVer, -params.lean_p_d / 2],
            [-(params.p_w / 2 + params.lean_p_w + offsetCB), params.lean_p_h + offsetHor, -(params.lean_p_d / 2)],
            [-(params.p_w / 2 + params.lean_p_w + offsetCB), 0.2, -params.lean_p_d / 2],
            [-(params.p_w / 2 + params.lean_p_w + offsetCB), 0.2, -params.lean_p_d / 2 + parseInt(params.add_storage)],
            [-(params.p_w / 2 + params.lean_p_w + offsetCB), params.lean_p_h + offsetHor, -params.lean_p_d / 2 + parseInt(params.add_storage)],
            [-(params.p_w / 2 + offsetCB), params.lean_p_h + params.lean_p_w * params.b_l_t_r_p / 12 + offsetVer, -params.lean_p_d / 2 + parseInt(params.add_storage)],
        ]
    ), [params.p_w, params.lean_p_w, params.lean_p_d, params.lean_p_h, params.b_l_t_r_p, params.add_storage])

    return (
        <>
            <Line
                points={topLinePoints}
                color="#00BE00"
                lineWidth={3}
                dashSize={0.3}
                gapSize={0.1}
                dashed
            />
            <Html occlude position={[-params.p_w / 2 - 0.5, params.lean_p_h + params.lean_p_w * params.b_l_t_r_p / 12 + 0.3, -params.lean_p_d / 2 + parseInt(params.add_storage) / 2]} style={{ pointerEvents: 'none' }}>
                <span style={{backgroundColor: 'white', border: 'solid 2px #00BE00', color: 'black', borderRadius: '50%', cursor: 'pointer', display:'flex', alignItems: 'center', justifyContent: 'center', padding: '3px', userSelect: 'none', fontSize: 'smaller'}}>
                    <i className='icon-drag-ico'/>
                </span>
            </Html>
        </>
    )
}

export default OutLineSection